import React from 'react';

import { VisuallyHidden } from 'shared/components/visually-hidden';
import { PlusIcon } from 'src/assets/plus';
import { Add, Discount, DiscountedPrice, Option, OriginalPrice } from './option.styles';

type OptionTileProps = {
  label: string;
  originalPrice: string | null;
  currentPrice: string;
  discountLabel: string | null;
  onClick: () => void;
  hasMultipleOptions: boolean;
  isOutlinedVariant?: boolean;
  isSelected?: boolean;
  isFixedSize?: boolean;
  shouldDisplayLabel?: boolean;
  listPriceEnabled?: boolean;
  hideStrikethrough?: boolean;
};

export const OptionTile = ({
  label,
  originalPrice,
  currentPrice,
  discountLabel,
  onClick,
  hasMultipleOptions,
  isOutlinedVariant = true,
  isSelected = false,
  isFixedSize = false,
  shouldDisplayLabel = true,
  listPriceEnabled = false,
  hideStrikethrough = false,
}: OptionTileProps): JSX.Element => {
  const showDiscount = !!(discountLabel && originalPrice && !hideStrikethrough);

  return (
    <Option
      $hasMultipleOptions={hasMultipleOptions}
      $isOutlinedVariant={isOutlinedVariant}
      $isSelected={isSelected}
      $isFixedSize={isFixedSize}
      onClick={onClick}
      data-testid='option-tile'
    >
      {shouldDisplayLabel && label}

      <b>{currentPrice}</b>

      {discountLabel && originalPrice && (
        <DiscountedPrice $hasMultipleOptions={hasMultipleOptions}>
          <OriginalPrice $listPriceEnabled={listPriceEnabled} $hideStrikethrough={hideStrikethrough}>
            {originalPrice}
          </OriginalPrice>
          {showDiscount && <Discount $listPriceEnabled={listPriceEnabled}>{discountLabel}</Discount>}
        </DiscountedPrice>
      )}

      {!isOutlinedVariant && (
        <Add>
          <VisuallyHidden>Add {label} to cart</VisuallyHidden>
          <PlusIcon height={10} width={10} />
        </Add>
      )}
    </Option>
  );
};
